import Actions              from "../../../model/constant/actions"
import ReducerUtils         from "../../../utils/ReducerUtils"

const FailedRetrievingBiddingStrategySettings = ReducerUtils.createReducer<boolean>(false,{
  [Actions.FAILED_RETRIEVING_BIDDING_STRATEGY_SETTINGS] : (_state,action) => action.status
})

export default FailedRetrievingBiddingStrategySettings
